module.exports = __webpack_public_path__ + "img/cs_center_icon.c63a08f8.png";